<script setup lang="ts">
import { defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { useOnboardingStore } from '@/store/onboarding/onboardingStore'

const onboarding = useOnboardingStore()
const { t } = useI18n()

defineProps({
  display: Boolean,
})

const noLongerDisplay = async () => {
  await onboarding.resetOnboarding()
  onboarding.visible == false
  await onboarding.toggleOnboarding(true)
  onboarding.leave = true
}

const close = () => {
  onboarding.onboardingAlert = false
  setTimeout(() => (onboarding.visible = true), 300)
}

const emit = defineEmits(['confirmDelete', 'cancel'])

const later = async () => {
  onboarding.continueLater = true
  ;(onboarding.visible = false), (onboarding.onboardingAlert = false)

  await onboarding.toggleOnboarding(true)
  onboarding.leave = true
}
</script>

<template>
  <v-dialog persistent :model-value="display" width="650">
    <v-card
      :disabled="onboarding.loading"
      max-width="450"
      color="white"
      transition="dialog-top-transition"
    >
      <v-card-title
        class="py-3 d-flex justify-center w-full align-center bg-surface-lighten-1"
      >
        <span class="font-weight-bold title">{{
          $t('onboarding.discoverHolitime')
        }}</span>
        <img
          style="position: absolute; right: 10px"
          class="cursor-pointer mr-2"
          @click="() => close()"
          src="@/assets/_close.svg"
        />
      </v-card-title>

      <div>
        <v-img eager src="@/assets/dashboard/onboarding-alert.jpg" />
        <div class="px-5 d-flex flex-column ga-4">
          <p class="start">
            {{ $t('onboarding.modalAlertTitle') }}
          </p>

          <p class="start-desc">{{ $t('onboarding.modalAlertDesc') }}</p>
        </div>
      </div>

      <div class="px-5 py-5">
        <div class="d-sm-flex ga-sm-2">
          <v-btn
            color="#E0E0E0"
            class="w-sm-50 w-100"
            @click="() => noLongerDisplay()"
          >
            <span class="font-weight-bold" style="color: #757575">{{
              $t('onboarding.noLongerDisplay')
            }}</span>
          </v-btn>

          <v-btn
            color="#12C29B"
            class="w-sm-50 w-100 mt-sm-0 mt-2 text-white"
            @click="() => later()"
            >{{ $t('onboarding.continueLater') }}</v-btn
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.title {
  color: #007058;
  font-weight: 600px;
  font-size: 20px;
  line-height: 32.2px;
}

.start {
  color: #007058;
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  letter-spacing: -1.2px;
  text-align: center;
}

.start-desc {
  color: #757575;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: -0.32px;
  text-align: center;
}

@media (max-width: 599px) {
  .title {
    font-size: 16px;
  }
  .start {
    font-size: 18px;
  }
  .start-desc {
    font-size: 12px;
  }
}
</style>
